function EmploymentType(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="prefix__lucide prefix__lucide-id-card-lanyard-icon prefix__lucide-id-card-lanyard"
      {...props}
    >
      <path d="M13.5 8h-3M15 2l-1 2h3a2 2 0 012 2v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2h3M16.899 22A5 5 0 007.1 22M9 2l3 6" />
      <circle cx={12} cy={15} r={3} />
    </svg>
  )
}

export default EmploymentType
